import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReportUserService } from 'app/services/report-user.service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-report-roles-permission',
  templateUrl: './report-roles-permission.component.html',
  styleUrls: ['./report-roles-permission.component.css']
})
export class ReportRolesPermissionComponent implements OnInit {

  @Output() infoReport = new EventEmitter<string>();
  @Output() showInfo = new EventEmitter<boolean>();

  showReport: boolean;
  showReportRolesPermission: boolean;
  report;

  companies: SelectItem[] = [];
  companySelectedRolesPermission;

  constructor(private reportService: ReportUserService, private translate: TranslateService) { }

  ngOnInit() {
    // ottengo le company e popolo la dropdown
    this.reportService.getCompanies().subscribe(res => {
      this.companies = res;
    });
  }

  reportRolesPermission() {
    if (this.companySelectedRolesPermission == null) {
      this.companySelectedRolesPermission = this.companies[0].value;
    }

    this.showReport = false;
    this.reportService.getReportRolesPermission(this.companySelectedRolesPermission).subscribe(res => {
      this.showReport = true;
      this.report = res;
      this.showReportRolesPermission = true;
    });
  }

  openDialog(reportType) {
    this.infoReport.emit(this.translate.instant(`report.${reportType}`));
    this.showInfo.emit(true);
  }

  closeDialogReport() {
    this.showReport = false;
    this.showReportRolesPermission = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/report-user/report-roles-permission/report-roles-permission.component.ts